var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup d-flex justify-content-center align-items-center",
      class: { "popup--visible": _vm.is_open },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-10 col-lg-8 popup__container" },
            [
              _vm.is_open
                ? _c("div", {}, [
                    _c(
                      "a",
                      {
                        staticClass: "popup__close",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.closePopup.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "popup__close__ico",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              viewBox: "0 0 16 16",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "desktop_design",
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "cart",
                                      transform:
                                        "translate(-512.000000, -28.000000)",
                                      stroke: "#93999C",
                                      "stroke-width": "1.4",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "icon/closeGrey",
                                          transform:
                                            "translate(513.000000, 29.000000)",
                                        },
                                      },
                                      [
                                        _c("line", {
                                          attrs: {
                                            x1: "14",
                                            y1: "0",
                                            x2: "0",
                                            y2: "14",
                                            id: "Stroke-429",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "14",
                                            y1: "14",
                                            x2: "0",
                                            y2: "0",
                                            id: "Stroke-430",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "popup__title font__family--gotham font__weight--medium font__color--gray",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("forgot_password", "user_account")
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "popup__desc font__family--gotham font__weight--light font__color--gray-light",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("forgot_password_desc", "user_account")
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group form-group__animated",
                            class: {
                              "form-group--error": !_vm.validate.addressEmail,
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addressEmail,
                                  expression: "addressEmail",
                                },
                              ],
                              staticClass:
                                "form-group__input form-group__input--paddings-classic form-group__animated__input",
                              attrs: {
                                type: "email",
                                name: "email",
                                id: "address_email",
                                placeholder: "Adres email",
                              },
                              domProps: { value: _vm.addressEmail },
                              on: {
                                blur: _vm.validateAddressEmail,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.addressEmail = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-group__animated__label",
                                attrs: { for: "address_email" },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$t("email", "form_company_data")
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "py-2 position-relative text-center" },
                          [
                            _c("p", { staticClass: "msg__small w-100 m-0" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.return_msg) +
                                  "\n                                "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center mt-5" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "button button__size-2 button__font--size-1 button__bg--dark",
                            class: {
                              "button__bg--blue btn-loader": _vm.loader,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.forgot_password.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "font__family--gotham font__weight--medium font__color--white",
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("reset", "user_account")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }